import { H3 } from '../StyledText'
import styled from 'styled-components'
import { colors } from '../../styles'

export const StyledTitle = styled(H3)`
  & span {
    color: ${colors.grey40};
  }
` as any

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 12px;
`

export const StyledDetailsPanel = styled.div`
  p {
    word-break: break-all;
    padding-right: 12px;
  }
`
